var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCeneo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 102 28",
    style: {
      enableBackground: "new 0 0 102 28"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FF6400;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M18.2,25.1c0,0.9-3.1,2.6-7.1,2.6l0,0c-7.4,0-11-4.5-11-13.7c0-9,3.9-14,11-14l0,0c1.4,0,3.1,0.4,4.7,1.2 c1.1,0.5,2.4,1.3,2.4,1.8c0,0.2,0,0.4-0.3,0.7l-1.6,2.1c-0.1,0.2-0.4,0.4-0.6,0.4c-0.3,0-0.6-0.2-1.1-0.6 c-0.8-0.5-1.8-1.2-3.2-1.2c-3.6,0-5.1,2.4-5.1,8.6c0,3.6,0.3,6,1,7.5c0.8,1.8,2.1,2.7,4.1,2.7c1.4,0,2.6-0.5,3.4-0.9 c0.5-0.3,1-0.5,1.3-0.5c0.3,0,0.5,0.2,0.6,0.5l1.3,2.2C18.1,24.7,18.2,24.9,18.2,25.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M27.4,5.1v6h7c0.4,0,0.7,0,0.8,0.2c0.2,0.2,0.2,0.4,0.2,0.8v2.5c0,0.8-0.3,1-1,1h-7v7.2h8.8c0.8,0,1,0.2,1,1 v2.5c0,0.8-0.2,1-1,1H22.4c-0.4,0-0.7,0-0.8-0.2s-0.2-0.4-0.2-0.8l0.1-24.5c0-0.8,0.3-1,1-1h13.8c0.7,0,1.2,0.1,1.2,0.6 c0,0.2,0,0.3-0.1,0.4l-0.9,2.7c-0.2,0.7-0.9,0.7-1.1,0.7l0,0L27.4,5.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M60.2,1.7l-0.1,24.5c0,0.8-0.2,1-1,1h-2.8c-0.6,0-0.8-0.1-1.1-0.6l-7.6-13c-1.1-1.8-1.7-3-2.1-4.3l0,0 c0,0.9,0.1,2.1,0.1,3.2v13.7c0,0.8-0.3,1-1,1h-3c-0.8,0-1-0.2-1-1l0.1-24.5c0-0.8,0.3-0.9,1-0.9h3.5c0.7,0,0.8,0.1,1.1,0.6 l6.9,11.8c1.1,1.9,1.8,3.6,2.2,4.9c0-0.6,0-1.3-0.1-2c0-0.9-0.1-1.8-0.1-2.3V1.7c0-0.8,0.3-0.9,1-0.9h3.1 C59.9,0.7,60.2,0.9,60.2,1.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M69.8,5.2v6h7c0.4,0,0.7,0,0.8,0.2c0.2,0.2,0.2,0.4,0.2,0.8v2.5c0,0.7-0.2,1-1,1h-7v7.2h8.8c0.8,0,1,0.2,1,1 v2.5c0,0.8-0.2,0.9-1,0.9H64.8c-0.8,0-1-0.2-1-1l0.1-24.5c0-0.8,0.3-1,1-1h13.8c0.7,0,1.2,0,1.2,0.6c0,0.2,0,0.3-0.1,0.4l-0.9,2.7 c-0.2,0.7-0.8,0.7-1.1,0.7L69.8,5.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M99.1,3.7c-1.8-2.3-4.4-3.5-7.8-3.5c-6.8,0-10.6,4.9-10.6,13.9c0,4.5,0.9,8,2.8,10.4c1.8,2.3,4.4,3.5,7.8,3.5 l0,0c6.8,0,10.6-4.9,10.6-13.8C101.8,9.6,100.9,6,99.1,3.7z M91.3,4.5c0.9,0,1.6,0.3,2.3,0.9c1.4,1.4,2.1,4.3,2.1,8.6 s-0.8,9.5-4.4,9.5S87,18.3,87,14C86.9,9.7,87.8,4.5,91.3,4.5C91.3,4.5,91.3,4.5,91.3,4.5z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCeneo);
export default __webpack_public_path__ + "static/media/ceneo.0c97e8b9ed04a2fa95c05d33c875aded.svg";
export { ForwardRef as ReactComponent };